<div class="main-wrapper-layout">
  <header>
    <div class="head-2">
      <div class="bl-pro">
        <!-- Top navigation-->
        <nav class="navbar navbar-expand-lg navbar-light">
          <div class="container-fluid">
            <ul class="navbar-nav top-nav ms-auto mt-2 mt-lg-0">
              <!-- <li class="nav-item ">
                <a class="nav-link">
                  <a>
                    <div class="circ-name">
                      <img src="../../../assets/images/avatar.jpg" alt="" class="avatar" />
                    </div>
                  </a>
                </a>
              </li> -->
              <div class="name">
                {{displayName}}
                <span>
                  {{designation}} - {{department}}
                </span>
              </div>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <div class="header-right">
      <!-- <a href="#"><i class="bi bi-box-arrow-right"></i></a> -->
      <!-- <a href="#"><i class="bi bi-gear"></i></a> -->
    </div>
  </header>
  <!-- <aside class="left-sidebar">
    <div class="left-menu-outer">
      <div class="left-head">
        <span>ESA OFFICE SUITE</span> <a href="#" id="left-toogle"><i class="bi bi-chevron-left"></i></a>
      </div>
      <div onclick="closeNav()" id="main" class="left-menu">
        <ul>
          <li [ngClass]="{'active': currentMenu=='Dashboard'}">
            <a (click)="currentMenu='Dashboard';openMenu();">
              <i class="bi bi-speedometer2"></i> <span>Dashboard</span>
            </a>
          </li>
          <li [ngClass]="{'active': currentMenu=='INM'}">
            <a (click)="currentMenu='INM';openINM();">
              <i class="bi bi-file-earmark-ruled-fill"></i> <span>Internal Notes Management</span>
            </a>
            <div class="hover-menu">
              <ul>
                <li><a (click)="INMDashboard()"><i class="bi bi-dash"></i>Dashboard</a></li>
                <li><a (click)="INMSettings()"><i class="bi bi-sett"></i>Settings</a></li>
                <li><a (click)="INMTransactions()"><i class="bi bi-trans"></i>Transactions</a></li>
                <li><a (click)="INMReports()"><i class="bi bi-rep"></i>Reports</a></li>
              </ul>
            </div>
          </li>
          <li [ngClass]="{'active': currentMenu=='MM'}">
            <a (click)="currentMenu='MM';openMM();">
              <i class="bi bi-people"></i><span>Meeting Management</span>
            </a>
            <div class="hover-menu">
              <ul>
                <li><a (click)="MMDashboard()"><i class="bi bi-dash"></i>Dashboard</a></li>
                <li><a (click)="MMSettings()"><i class="bi bi-sett"></i>Settings</a></li>
                <li><a (click)="MMTransactions()"><i class="bi bi-trans"></i>Transactions</a></li>
                <li><a (click)="MMReports()"><i class="bi bi-rep"></i>Reports</a></li>
              </ul>
            </div>
          </li>
          <li [ngClass]="{'active': currentMenu=='CR'}">
            <a (click)="currentMenu='CR';openCR();">
              <i class="bi bi-newspaper"></i> <span>Circular Resolutions</span>
            </a>
            <div class="hover-menu">
              <ul>
                <li><a (click)="CRDashboard()"><i class="bi bi-dash"></i>Dashboard</a></li>
                <li><a (click)="CRSettings()"><i class="bi bi-sett"></i>Settings</a></li>
                <li><a (click)="CRTransactions()"><i class="bi bi-trans"></i>Transactions</a></li>
                <li><a (click)="CRReports()"><i class="bi bi-rep"></i>Reports</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </aside> -->
  <section class="main-wrapper-2">
    <div class="dashboard-container">
      <router-outlet></router-outlet>
    </div>
  </section>
  <footer>
    <div class="container1-fluid">
      <div class="footerWrp">
        <div class="footTxt1">ESAF SMALL FINANCE BANK © Copyright 2023. All rights reserved.</div>
        <div class="footTxt2">Powered by &nbsp; <a href="https://www.gramproindia.com/" target="_blank">Grampro Business
            Services</a></div>
      </div>
    </div>
  </footer>
</div>
<kendo-dialog title="Change Password" *ngIf="resetPassword" (close)="closeResetPassword()" [width]="700">
  <app-passwordreset (closeChangePassword)="closeChangePassword()"> </app-passwordreset>
</kendo-dialog>